import jschardet from 'jschardet';
import Papa from 'papaparse';

const XLSX = require('xlsx');

export function readXlsx(file, callback) {
  let rABS = false; // 是否将文件读取为二进制字符串
  let reader = new FileReader();
  FileReader.prototype.readAsBinaryString = function readAsBinaryString(f) {
    let binary = '';
    let wb; // 读取完成的数据
    let outdata;
    reader.onload = function onload() {
      const bytes = new Uint8Array(reader.result);
      const length = bytes.byteLength;
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      if (rABS) {
        wb = XLSX.read(btoa(fixdata(binary)), { // 手动转化
          type: 'base64',
        });
      } else {
        wb = XLSX.read(binary, {
          type: 'binary',
        });
      }
      outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);// outdata就是你想要的东西
      callback && callback(outdata);
      binary = null;
      rABS = null;
      wb = null;
      outdata = null;
      reader = null;
    };
    reader.readAsArrayBuffer(f);
  };
  if (rABS) {
    reader.readAsArrayBuffer(file);
  } else {
    reader.readAsBinaryString(file);
  }
}

function fixdata(data) {
  let o = '';
  let l = 0;
  const w = 10240;
  for (; l < data.byteLength / w; ++l) {
    o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
  }
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
}

export function csv2arr(file, callback) {
  if (typeof (FileReader) === 'undefined') { // if not H5
    return false;
  }
  if (!file) {
    return false;
  }
  const fReader = new FileReader();
  fReader.readAsDataURL(file);
  fReader.onload = function (evt) {
    const data = evt.target.result;
    const encoding = checkEncoding(data);
    Papa.parse(file, {
      encoding,
      complete(results) {
        const res = results.data;
        if (res[res.length - 1] === '') { // 去除最后的空行
          res.pop();
        }
        callback && callback(res);
      },
    });
  };
  fReader.onerror = function (evt) {
  };
}

function checkEncoding(base64Str) {
  const str = atob(base64Str.split(';base64,')[1]);
  let encoding = jschardet.detect(str);
  encoding = encoding.encoding;
  if (encoding === 'windows-1252') { // 有时会识别错误（如UTF8的中文二字）
    encoding = 'ANSI';
  }
  return encoding;
}
